var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m392 0h-272c-66.167969 0-120 53.832031-120 120v272c0 66.167969 53.832031 120 120 120h272c66.167969 0 120-53.832031 120-120v-272c0-66.167969-53.832031-120-120-120zm80 392c0 44.113281-35.886719 80-80 80h-272c-44.113281 0-80-35.886719-80-80v-272c0-44.113281 35.886719-80 80-80h272c44.113281 0 80 35.886719 80 80zm-216-249c-62.308594 0-113 50.691406-113 113s50.691406 113 113 113 113-50.691406 113-113-50.691406-113-113-113zm0 186c-40.253906 0-73-32.746094-73-73s32.746094-73 73-73 73 32.746094 73 73-32.746094 73-73 73zm157.332031-205.332031c0 13.804687-11.191406 25-25 25-13.804687 0-25-11.195313-25-25 0-13.808594 11.195313-25 25-25 13.808594 0 25 11.191406 25 25zm0 0",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.06f321039854e33857b41ef8d211c3c9.svg";
export { ForwardRef as ReactComponent };